import { IFormViewForm } from 'components/FormView';

const DiaryDetails: IFormViewForm = {
  id: 'PurchaseDiaryDetails',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: '1',
      type: 'PAPER_CONTAINER',
      props: {
        name: 'notepad',
        fullWidth: true
      },
      position: {
        row: 1,
        col: 1,
        colspan: 2
      },
      children: [
        {
          id: 1,
          type: 'DIARY_DETAILS',
          props: {
            label: 'SupplierCreditDiary',
            name: 'SupplierCreditDiary',
            createApi: '/SupplierEnquiry/Supplier/<Supplier>/CreatePurchaseDiary',
            searchByIdApi: '/SupplierEnquiry/Supplier/<Supplier>/PurchaseDiary/<DiaryId>',
            updateApi: '/SupplierEnquiry/Supplier/<Supplier>/PurchaseDiary/<DiaryId>',
            deleteApi: '/SupplierEnquiry/Supplier/<Supplier>/PurchaseDiary/<DiaryId>',
            diaryType: 'PURCHASE'
          }
        }
      ]
    }
  ]
};
export default DiaryDetails;
